import { APIGetLoggerReadingsModel } from '../../models/APIGetLoggerReadingsModel';
import ExcelJS, { Column } from 'exceljs';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { PreviousValueArray } from './GraphUtilityFunctions'
import { GraphTemplate } from '../../models/GraphTemplateModel'
import moment from 'moment'
import { flowConverter, pressureConverter, totalConverter, pressureUnits } from '../../Utils/UnitConverters'
import { IntlShape } from 'react-intl';
import { APILoggerDetail } from '../../models/APILoggerDetail';
interface ExportLoggerReadingsModel extends APIGetLoggerReadingsModel {
    dateStampLocalDay: number
    dateStampLocalMonth: number
    dateStampLocalYear: number
    timeStampLocal: string
    originalDateStamp: Date
    formattedDateStamp: string
    adjustDateStamp: string
    dateStampDay: number
    dateStampMonth: number
    dateStampYear: number
    timeStamp: string
    flowRateFWD: number | null
    flowRateREV: number | null
    consumptionUnit: string
    consumption: number | null
    flowUnit: string
    totalUnit: string
    forwardTotal: number | null
    pressureUnit: string
    pressureValue: number
    loggerSerialNumber: number
    digital: string | null
}


export const exportConfirm = (
    toggleExportModal: () => void,
    setLoading: (loading: boolean) => void,
    readingsData: ExportLoggerReadingsModel[],
    unitsAndValues: GraphTemplate[],
    splitDate: boolean,
    exportAs: string,
    startDate: Date,
    endDate: Date,
    groupId: number | null,
    loggers: Array<APILoggerDetail>,
    site: number | null,
    reloadData: (groupIdArg: number | null, loggersArg: APILoggerDetail[], site: number | null, dateChange: boolean) => void,
    intl: IntlShape

): void => {

    let readingsDataTemp: Array<ExportLoggerReadingsModel> = []
    toggleExportModal();
    setLoading(true)
    const workbook = new ExcelJS.Workbook();
    readingsData.forEach(reading => {
        reading.dateStampLocalDay = 0
        reading.dateStampLocalMonth = 0
        reading.dateStampLocalYear = 0
        reading.timeStampLocal = ""
        reading.originalDateStamp = new Date()
        reading.formattedDateStamp = ""
        reading.adjustDateStamp = ""
        reading.dateStampDay = 0
        reading.dateStampMonth = 0
        reading.dateStampYear = 0
        reading.timeStamp = ""
        reading.flowRateFWD = 0
        reading.flowRateREV = 0
        reading.consumptionUnit = ""
        reading.consumption = 0
        reading.flowUnit = ""
        reading.totalUnit = ""
        reading.forwardTotal = 0
        reading.pressureUnit = ""
        reading.pressureValue = 0
    })
    readingsDataTemp = [...readingsData];
    let worksheet: ExcelJS.Worksheet | null = null;
    const previousValueAArray: PreviousValueArray[] = []
    const previousValueBArray: PreviousValueArray[] = []
    unitsAndValues.forEach(entry => {
        if (entry.channelsAvail & 0x01) {
            previousValueAArray.push({ serial: entry.serial, value: null })
        }
        if (entry.channelsAvail & 0x02) {
            previousValueBArray.push({ serial: entry.serial, value: null })
        }
    })
    readingsDataTemp.forEach(item => {
        // Get UTC Offset
        const offset = sessionStorage.getItem('utcOffset')
        let utcOffset = 0
        let offsetType = ""
        if (offset) {
            utcOffset = parseInt(offset.slice(1));
            offsetType = offset.slice(0, 1);
        }

        // Adjust dateStamp based on offset
        const originalDate = moment.utc(item.dateStamp);
        let adjustedDate;

        if (offsetType === "-") {
            adjustedDate = originalDate.clone().subtract(utcOffset, 'hours');
        } else if (offsetType === "+") {
            adjustedDate = originalDate.clone().add(utcOffset, 'hours');
        } else {
            adjustedDate = originalDate;
        }



        // Save both formatted and raw date data
        item.dateStampLocalDay = parseInt(adjustedDate.format('DD'));
        item.dateStampLocalMonth = parseInt(adjustedDate.format('MM'));
        item.dateStampLocalYear = parseInt(adjustedDate.format('YYYY'));
        item.timeStampLocal = adjustedDate.format('HH:mm:ss');
        item.originalDateStamp = originalDate.toDate();
        item.formattedDateStamp = originalDate.format('DD/MM/YY HH:mm:ss')
        item.adjustDateStamp = adjustedDate.format('DD/MM/YY HH:mm:ss')
        item.dateStampDay = parseInt(originalDate.format('DD'));
        item.dateStampMonth = parseInt(originalDate.format('MM'));
        item.dateStampYear = parseInt(originalDate.format('YYYY'));
        item.timeStamp = originalDate.format('HH:mm:ss');
        item.digital = item.channelType === 51 ? item.value === 1 ? 'ON' : 'OFF' : null





        const loggerToExport = unitsAndValues.filter(unit => unit.serial === parseInt(item.loggerSerial))[0]





        //flow

        if (item.flowRate !== null) {
            if (item.flowRate > 0) {
                item.flowRateFWD = item.flowRate
                item.flowRateREV = 0
            } else if (item.flowRate < 0) {
                item.flowRateREV = Math.abs(item.flowRate)
                item.flowRateFWD = 0
            } else {
                item.flowRateFWD = 0
                item.flowRateREV = 0
            }
            let previousValueA: number | null = null
            let previousValueB: number | null = null

            if (item.channelletter === 'A') {
                if (moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second') && loggerToExport.graphSettings.flowAConsumptionVisible) {
                    previousValueAArray.forEach(i => {
                        if (i.serial === parseInt(item.loggerSerial)) {
                            if (i.value === null) {
                                i.value = item.value
                            }
                            previousValueA = i.value
                        }
                    })
                    item.consumptionUnit = loggerToExport.graphSettings.flowAConsumptionUnit
                    const consumptionConversion = totalConverter(item.consumptionUnit, item.units)
                    if (item.value && previousValueA) {
                        item.consumption = parseFloat(((item.value - previousValueA) * consumptionConversion).toFixed(3))
                    }
                }
                item.flowUnit = loggerToExport.graphSettings.flowAUnit
                item.totalUnit = loggerToExport.graphSettings.flowATotalUnit
                const flowConversion = flowConverter(item.flowUnit, 'l/s')
                const totalConversion = totalConverter(item.totalUnit, item.units)
                item.flowRateFWD = item.digital ? null : parseFloat((item.flowRateFWD * flowConversion).toFixed(3))

                item.channelletter = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Flow A' }) : intl.formatMessage({ id: 'Channel A' })
                if (item.value) {
                    item.forwardTotal = item.digital ? null : parseFloat((item.value * totalConversion).toFixed(3))
                }


            }


            if (item.channelletter === 'B') {

                if (moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second') && loggerToExport.graphSettings.flowBConsumptionVisible) {

                    previousValueBArray.forEach(i => {
                        if (i.serial === parseInt(item.loggerSerial)) {
                            if (i.value === null) {
                                i.value = item.value
                            }
                            previousValueB = i.value
                        }
                    })
                    item.consumptionUnit = loggerToExport.graphSettings.flowBConsumptionUnit
                    const consumptionConversion = totalConverter(item.consumptionUnit, item.units)
                    if (item.value && previousValueB) {
                        item.consumption = parseFloat(((item.value - previousValueB) * consumptionConversion).toFixed(3))
                    }
                }
                item.flowUnit = loggerToExport.graphSettings.flowBUnit
                item.totalUnit = loggerToExport.graphSettings.flowBTotalUnit
                const flowConversion = flowConverter(item.flowUnit, 'l/s')
                const totalConversion = totalConverter(item.totalUnit, item.units)

                item.flowRateFWD = item.digital ? null : parseFloat((item.flowRateFWD * flowConversion).toFixed(3))

                item.channelletter = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Flow B' }) : intl.formatMessage({ id: 'Channel B' })

                if (item.value) {
                    item.forwardTotal = item.digital ? null : parseFloat((item.value * totalConversion).toFixed(3))
                }

            }

        }
        if (item.value !== null) {

            if (item.channelletter === 'C') {
                let conversion = 1
                const settingsUnit = loggerToExport.graphSettings.pressureCUnit
                if (pressureUnits.map(unit => unit.value).includes(settingsUnit)) {
                    conversion = pressureConverter(settingsUnit, item.units)
                }
                item.value *= conversion
                item.channelletter = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure C' }) : intl.formatMessage({ id: 'Analog C' })
                item.pressureValue = parseFloat(item.value.toFixed(3))
                item.pressureUnit = loggerToExport.graphSettings.pressureCUnit

            }
            if (item.channelletter === 'D') {
                let conversion = 1
                const settingsUnit = loggerToExport.graphSettings.pressureDUnit
                if (pressureUnits.map(unit => unit.value).includes(settingsUnit)) {
                    conversion = pressureConverter(settingsUnit, item.units)
                }
                item.value *= conversion
                item.channelletter = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure D' }) : intl.formatMessage({ id: 'Analog D' })
                item.pressureValue = parseFloat(item.value.toFixed(3))
                item.pressureUnit = loggerToExport.graphSettings.pressureDUnit
            }
            if (item.channelletter === 'E') {
                let conversion = 1
                const settingsUnit = loggerToExport.graphSettings.pressureEUnit
                if (pressureUnits.map(unit => unit.value).includes(settingsUnit)) {
                    conversion = pressureConverter(settingsUnit, item.units)
                }
                item.value *= conversion
                item.channelletter = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure E' }) : intl.formatMessage({ id: 'Analog E' })
                item.pressureValue = parseFloat(item.value.toFixed(3))
                item.pressureUnit = loggerToExport.graphSettings.pressureEUnit
            }
        }
        if (moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second')) {
            if (item.channelletter === intl.formatMessage({ id: 'Flow A' }) || item.channelletter === intl.formatMessage({ id: 'Channel A' })) {
                previousValueAArray.forEach(i => {
                    if (i.serial === parseInt(item.loggerSerial)) {
                        i.value = item.value
                    }
                })
            }
            if (item.channelletter === intl.formatMessage({ id: 'Flow B' }) || item.channelletter === intl.formatMessage({ id: 'Channel B' })) {
                previousValueBArray.forEach(i => {
                    if (i.serial === parseInt(item.loggerSerial)) {
                        i.value = item.value
                    }
                })
            }
        }
        //ont the serial
        item.loggerSerialNumber = parseInt(item.loggerSerial)
    });


    readingsDataTemp.forEach(reading => {
        const loggerToExport = unitsAndValues.filter(unit => unit.serial === reading.loggerSerialNumber)[0]
        if ((loggerToExport.graphSettings.flowAVisible || loggerToExport.graphSettings.flowATotalVisible || loggerToExport.graphSettings.flowAConsumptionVisible) && (reading.channelletter === intl.formatMessage({ id: 'Flow A' }) || reading.channelletter === intl.formatMessage({ id: 'Channel A' }))) {
            if (!loggerToExport.graphSettings.flowAVisible) {
                reading.flowRateFWD = null
                reading.flowRateREV = null
                reading.flowUnit = ""
            }
            if (!loggerToExport.graphSettings.flowATotalVisible) {
                reading.forwardTotal = null
                reading.totalUnit = ""
            }
            if (!loggerToExport.graphSettings.flowAConsumptionVisible) {
                reading.consumption = null
                reading.consumptionUnit = ""
            }
            return reading
        }
        if ((loggerToExport.graphSettings.flowBVisible || loggerToExport.graphSettings.flowBTotalVisible || loggerToExport.graphSettings.flowBConsumptionVisible) && (reading.channelletter === intl.formatMessage({ id: 'Flow B' }) || reading.channelletter === reading.channelletter === intl.formatMessage({ id: 'Channel B' }))) {
            if (!loggerToExport.graphSettings.flowBVisible) {
                reading.flowRateFWD = null
                reading.flowRateREV = null
                reading.flowUnit = ""
            }
            if (!loggerToExport.graphSettings.flowBTotalVisible) {
                reading.forwardTotal = null
                reading.totalUnit = ""
            }
            if (!loggerToExport.graphSettings.flowBConsumptionVisible) {
                reading.consumption = null
                reading.consumptionUnit = ""
            }
            return reading
        }
        if (loggerToExport.graphSettings.pressureCVisible && (reading.channelletter === intl.formatMessage({ id: 'Pressure C' }) || reading.channelletter === intl.formatMessage({ id: 'Analog C' }))) {
            return reading
        }
        if (loggerToExport.graphSettings.pressureDVisible && (reading.channelletter === intl.formatMessage({ id: 'Pressure D' }) || reading.channelletter === intl.formatMessage({ id: 'Analog D' }))) {
            return reading
        }
        if (loggerToExport.graphSettings.pressureEVisible && (reading.channelletter === intl.formatMessage({ id: 'Pressure E' }) || reading.channelletter === intl.formatMessage({ id: 'Analog E' }))) {
            return reading
        }
        return
    })
    const filteredReadingDataTemp: Array<ExportLoggerReadingsModel> = []

    let readingsChannelA = readingsDataTemp.filter(reading => reading.channelletter === intl.formatMessage({ id: 'Flow A' }) || reading.channelletter === intl.formatMessage({ id: 'Channel A' }))
    let readingsChannelB = readingsDataTemp.filter(reading => reading.channelletter === intl.formatMessage({ id: 'Flow B' }) || reading.channelletter === intl.formatMessage({ id: 'Channel B' }))
    const readingsChannelC = readingsDataTemp.filter(reading => reading.channelletter === intl.formatMessage({ id: 'Pressure C' }) || reading.channelletter === intl.formatMessage({ id: 'Analog C' }))
    const readingsChannelD = readingsDataTemp.filter(reading => reading.channelletter === intl.formatMessage({ id: 'Pressure D' }) || reading.channelletter === intl.formatMessage({ id: 'Analog D' }))
    const readingsChannelE = readingsDataTemp.filter(reading => reading.channelletter === intl.formatMessage({ id: 'Pressure E' }) || reading.channelletter === intl.formatMessage({ id: 'Analog E' }))

    const sett = unitsAndValues.map(u => u.graphSettings)



    // FLOW A FILTERING
    /// all flow A are off?
    if (!sett.every(u => u.flowAVisible)) {
        // check if totals are all off and any A channel Consumption are on
        if (!sett.every(u => u.flowATotalVisible) && sett.some(u => u.flowAConsumptionVisible)) {

            readingsChannelA = readingsChannelA.filter(item => moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second'))
        }
        // if some totals are visible check and then only filter for the relevant serials
        if (sett.some(u => u.flowATotalVisible)) {
            // check which ones are 24hrs
            const dailySerials: Array<number | null> = []
            unitsAndValues.forEach(unit => {
                if (unit.graphSettings.flowATotalPerDay) {
                    dailySerials.push(unit.serial)
                }
            })
            /// chaecks channel A and filters out if logger has daily total
            readingsChannelA = readingsChannelA.filter(item => {
                if (dailySerials.includes(item.loggerSerialNumber) && moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second')) {
                    return item
                } else if (!dailySerials.includes(item.loggerSerialNumber)) {
                    return item
                } else return

            })
        }
    }
    if (!sett.every(u => u.flowBVisible)) {
        // check if totals are all off and any A channel Consumption are on
        if (!sett.every(u => u.flowBTotalVisible) && sett.some(u => u.flowBConsumptionVisible)) {

            readingsChannelB = readingsChannelB.filter(item => moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second'))
        }
        // if some totals are visible check and then only filter for the relevant serials
        if (sett.some(u => u.flowBTotalVisible)) {
            // check which ones are 24hrs
            const dailySerials: Array<number | null> = []
            unitsAndValues.forEach(unit => {
                if (unit.graphSettings.flowBTotalPerDay) {
                    dailySerials.push(unit.serial)
                }
            })
            /// chaecks channel A and filters out if logger has daily total
            readingsChannelB = readingsChannelB.filter(item => {
                if (dailySerials.includes(item.loggerSerialNumber) && moment(item.dateStamp).isSame(moment(item.dateStamp).startOf('day'), 'second')) {
                    return item
                } else if (!dailySerials.includes(item.loggerSerialNumber)) {
                    return item
                } else return

            })
        }
    }
    readingsChannelA.forEach(reading => {
        filteredReadingDataTemp.push(reading)
    })
    readingsChannelB.forEach(reading => {
        filteredReadingDataTemp.push(reading)
    })
    readingsChannelC.forEach(reading => {
        filteredReadingDataTemp.push(reading)
    })
    readingsChannelD.forEach(reading => {
        filteredReadingDataTemp.push(reading)
    })
    readingsChannelE.forEach(reading => {
        filteredReadingDataTemp.push(reading)
    })
    if (filteredReadingDataTemp.length > 0) {

        worksheet = workbook.addWorksheet(intl.formatMessage({ id: "All Channels" }), {
            views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }]
        });

        const highestChannelAvail = Math.max(...unitsAndValues.map(unit => unit.channelsAvail));
        let defaultHeaders = []
        if (splitDate) {
            defaultHeaders = [
                { header: intl.formatMessage({ id: "Serial" }), key: "loggerSerialNumber" },
                { header: intl.formatMessage({ id: "Device Name" }), key: "site", style: { width: 50 } },
                { header: intl.formatMessage({ id: "Day Local (UTC Offset)" }), key: "dateStampLocalDay", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Month Local (UTC Offset)" }), key: "dateStampLocalMonth", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Year Local (UTC Offset)" }), key: "dateStampLocalYear", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Time Local (UTC Offset)" }), key: "timeStampLocal", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Day (UTC)" }), key: "dateStampDay", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Month (UTC)" }), key: "dateStampMonth", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Year (UTC)" }), key: "dateStampYear", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Time (UTC)" }), key: "timeStamp", style: { width: 60 } },
                { header: intl.formatMessage({ id: "Channel" }), key: "channelletter" },
                { header: intl.formatMessage({ id: "Channel Name" }), key: "channelSerial" },

            ]
        } else {
            defaultHeaders = [
                { header: intl.formatMessage({ id: "Serial" }), key: "loggerSerialNumber" },
                { header: intl.formatMessage({ id: "Device Name" }), key: "site", style: { width: 50 } },
                { header: `${intl.formatMessage({ id: "Date" })} (UTC)`, key: "formattedDateStamp", style: { width: 80 } },
                { header: `${intl.formatMessage({ id: "Date" })} (Local)`, key: "adjustDateStamp", style: { width: 80 } },
                { header: intl.formatMessage({ id: "Channel" }), key: "channelletter" },
                { header: intl.formatMessage({ id: "Channel Name" }), key: "channelSerial" },

            ]
        }
        const headers = []
        headers.push(...defaultHeaders)
        if (unitsAndValues.some(({ graphSettings: { flowAVisible, flowBVisible } }) => flowAVisible || flowBVisible)) {
            if (unitsAndValues.some(({ graphSettings: { flowAIsDigital, flowBIsDigital } }) => flowAIsDigital || flowBIsDigital)) {
                headers.push({ header: intl.formatMessage({ id: "Digital" }), key: "digital" })
            }
            if (unitsAndValues.some(({ graphSettings: { flowAIsDigital, flowBIsDigital } }) => !flowAIsDigital || !flowBIsDigital)) {
                headers.push({ header: intl.formatMessage({ id: "Flow Rate Fwd" }), key: "flowRateFWD" })
                headers.push({ header: intl.formatMessage({ id: "Flow Rate Rev" }), key: "flowRateREV" })
                headers.push({ header: intl.formatMessage({ id: "Flow Unit" }), key: "flowUnit" })
            }
        }
        if (unitsAndValues.some(({ graphSettings: { flowATotalVisible, flowBTotalVisible } }) => flowATotalVisible || flowBTotalVisible)) {
            headers.push({ header: intl.formatMessage({ id: "Totaliser" }), key: "forwardTotal" })
            headers.push({ header: intl.formatMessage({ id: "Totaliser Unit" }), key: "totalUnit" })
        }

        if (unitsAndValues.some(({ graphSettings: { flowAConsumptionVisible, flowBConsumptionVisible } }) => flowAConsumptionVisible || flowBConsumptionVisible)) {
            headers.push({ header: intl.formatMessage({ id: "Consumption 24hrs" }), key: 'consumption' })
            headers.push({ header: intl.formatMessage({ id: "Consumption Unit" }), key: "consumptionUnit" })
        }




        if (highestChannelAvail >= 4 && unitsAndValues.some(({ graphSettings: { pressureCVisible } }) => pressureCVisible)) {
            headers.push({ header: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure C' }) : intl.formatMessage({ id: 'Analog C' }), key: "pressureValue" })
            headers.push({ header: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure C Unit' }) : intl.formatMessage({ id: 'Analog C Unit' }), key: "pressureUnit" })
        }
        if (highestChannelAvail >= 8 && unitsAndValues.some(({ graphSettings: { pressureDVisible } }) => pressureDVisible)) {
            headers.push({ header: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure D' }) : intl.formatMessage({ id: 'Analog D' }), key: "pressureValue" })
            headers.push({ header: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure D Unit' }) : intl.formatMessage({ id: 'Analog D Unit' }), key: "pressureUnit" })
        }
        if (highestChannelAvail >= 16 && !window.location.hostname.includes('zonelog.net') && unitsAndValues.some(({ graphSettings: { pressureEVisible } }) => pressureEVisible)) {
            headers.push({ header: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure E' }) : intl.formatMessage({ id: 'Analog E' }), key: "pressureValue" })
            headers.push({ header: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure E Unit' }) : intl.formatMessage({ id: 'Analog E Unit' }), key: "pressureUnit" })
        }

        worksheet.columns = headers;

        filteredReadingDataTemp.sort((a, b) => {
            const dateA = moment(a.originalDateStamp, 'Do MMM YYYY HH:mm:ss')
            const dateB = moment(b.originalDateStamp, 'Do MMM YYYY HH:mm:ss')
            if (dateA.isBefore(dateB)) return -1;
            if (dateA.isAfter(dateB)) return 1;
            return 0; // dates are equal
        });

        // Ensure no overlapping data when adding the table.
        const cleanData = filteredReadingDataTemp.filter(data => data !== undefined && data !== null);


        if (exportAs == "XLSX-T") {
            worksheet.addTable({
                name: 'DataTable',
                ref: 'A2', // Reference below the header row
                displayName: 'MyTable',
                columns: worksheet.columns.map(column => ({ name: column.header, filterButton: true })),
                rows: cleanData.map(data =>
                    worksheet.columns.map(column => {
                        // If column.key doesn't exist in data, fallback to empty string
                        return data[column.key];
                    })
                ),
            });

        } else {
            worksheet.addRows(filteredReadingDataTemp);
        }
    }

    const downloadName = window.location.hostname.includes('zonelog.net') ? `ZONELOG.NET ${intl.formatMessage({ id: 'Export' })}` : `Aquaguard ${intl.formatMessage({ id: 'Export' })}`
    if (exportAs == "CSV") {
        const zip = new JSZip();
        const promises = workbook.worksheets.map(sheet => {
            const options: ExcelJS.CsvWriteOptions = { sheetName: sheet.name, sheetId: sheet.id, dateUTC: true };
            return workbook.csv.writeBuffer(options)
                .then((buffer: Buffer) => zip.file(sheet.name + ".csv", buffer));
        });

        Promise.all(promises).then(() => {
            if (workbook.worksheets.length > 0) {
                zip.generateAsync({ type: "blob" }).then(content => {
                    saveAs(content, `${downloadName}-${intl.formatMessage({ id: 'Graph data from' })} ${moment(startDate).format('DDMMMYYYY')} ${intl.formatMessage({ id: 'to' })} ${moment(endDate).format('DDMMMYYYY')}.zip`);
                });
            }
            reloadData(groupId, loggers, site, true)
        });
    } else {

        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${downloadName}-${intl.formatMessage({ id: 'Graph data from' })} ${moment(startDate).format('DDMMMYYYY')} ${intl.formatMessage({ id: 'to' })}${moment(endDate).format('DDMMMYYYY')}.xlsx`);
        });
        reloadData(groupId, loggers, site, true)
    }

    setLoading(false)

};